import { create } from 'zustand'

interface ToastState {
  message: string
  type: 'success' | 'error' | 'info'
  isVisible: boolean
  show: (message: string, type?: 'success' | 'error' | 'info') => void
  hide: () => void
}

export const useToastStore = create<ToastState>()((set) => ({
  message: '',
  type: 'info',
  isVisible: false,

  show: (message, type = 'info') => {
    set({ message, type, isVisible: true })
  },

  hide: () => {
    set({ isVisible: false })
  },
}))
